const handleAlterMessage = (msg) => {
    const alter_html = `<div class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            ${msg}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>          
          </div>
        </div>
      </div>
    </div>`;
    const alter_modal = $(alter_html);
    alter_modal
        .find('.modal-body')
        .unbind('click')
        .bind('click', function (e) {
            alter_modal.modal('hide');
        });
    alter_modal
        .off('hidden.bs.modal')
        .on('hidden.bs.modal', function (e) {
            alter_modal.remove();
        })
        .modal('show');
};